import { Injectable } from '@angular/core';
import {HttpParams} from "@angular/common/http";
import {HttpClientService} from "./http-client.service";
import {Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class ImagenesLuminariaService {

  constructor(private http: HttpClientService) { }
  public getModelosByIdEmpresa(idEmpresa): Observable<any> {
    let params = new HttpParams().set("idEmpresa", idEmpresa);
    return this.http.getWithParams('/imagenes_luminaria/getmodelosbyidempresa', params);
  }

  public newModelo(nombre: string, imgOk: string, imgInactiv: string, imgErr: string, idEmpresa: string): Observable<any> {
    let body =
      {
        "nombre": nombre,
        "imgOk": imgOk,
        "imgInactiv": imgInactiv,
        "imgErr": imgErr,
        "idEmpresa": idEmpresa
      };
    return this.http.post('/imagenes_luminaria/newmodelo', body);
  }

  public editModelo(idModelo: string, nombre: string, imgOk: string, imgInactiv: string, imgErr: string): Observable<any> {
    let body =
      {
        "idModelo": idModelo,
        "nombre": nombre,
        "imgOk": imgOk,
        "imgInactiv": imgInactiv,
        "imgErr": imgErr
      };
    return this.http.patch('/imagenes_luminaria/editmodelo', body);
  }

  public assignModelo(idDispositivo: string, idModelo: string): Observable<any> {
    let body =
      {
        "idDispositivo": idDispositivo,
        "idModelo": idModelo
      };
    return this.http.patch('/imagenes_luminaria/assignmodelo', body);
  }

  public deleteModelo(idModelo: string): Observable<any> {
    return this.http.delete('/imagenes_luminaria/deletemodelo/' + idModelo);
  }

}
